import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

/** Converts API errors into short, actionable French messages for the interface. */
@Injectable({ providedIn: 'root' })
export class ApiErrorMessageService {
  message(error: unknown, fallback: string): string {
    const httpError = error as HttpErrorResponse;
    const body = httpError?.error;

    if (typeof body?.message === 'string' && body.message.trim()) return body.message;

    if (body?.errors && typeof body.errors === 'object') {
      const messages = Object.values(body.errors)
        .flatMap(value => Array.isArray(value) ? value : [value])
        .filter((value): value is string => typeof value === 'string' && !!value.trim());
      if (messages.length) return [...new Set(messages)].join(' ');
    }

    if (httpError?.status === 0) return 'Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.';
    if (httpError?.status === 401) return 'Votre session a expiré. Veuillez vous reconnecter.';
    if (httpError?.status === 403) return 'Vous n’avez pas les droits requis pour effectuer cette action.';
    if (httpError?.status === 404) return 'L’élément demandé est introuvable ou n’est plus accessible.';
    if (httpError?.status === 409) return 'Cette action entre en conflit avec des données existantes.';
    if (httpError?.status >= 500) return 'Le serveur a rencontré un problème. Réessayez dans quelques instants.';

    return fallback;
  }
}
